import { Box, Button, ColumnLayout, FormField, Input, Modal, SpaceBetween, } from "@cloudscape-design/components-themed/components";
import React, { useEffect, useState } from "react";
const ConfirmationModal = (props) => {
    var _a;
    const headerText = "Rotate Credentials";
    const [rotateInputText, setRotateInputText] = useState("");
    const [isRotateLoading, setIsRotateLoading] = useState((props === null || props === void 0 ? void 0 : props.isRotateLoading) || false);
    const inputMatchesConsentText = rotateInputText === props.rotateModalStrings.consentText;
    useEffect(() => {
        setRotateInputText("");
    }, [props.visible]);
    useEffect(() => {
        setIsRotateLoading((props === null || props === void 0 ? void 0 : props.isRotateLoading) || false);
    }, [props === null || props === void 0 ? void 0 : props.isRotateLoading]);
    const handleRotateSubmit = (event) => {
        event.preventDefault();
        if (inputMatchesConsentText) {
            props.onRotate();
        }
    };
    return (React.createElement(Modal, { visible: props.visible, onDismiss: props.onDiscard, header: ((_a = props.rotateModalStrings) === null || _a === void 0 ? void 0 : _a.headerConfirmModalText) || headerText, closeAriaLabel: "Close dialog", footer: React.createElement(Box, { float: "right" },
            React.createElement(SpaceBetween, { direction: "horizontal", size: "xs" },
                React.createElement(Button, { variant: "link", onClick: props.onDiscard }, "Cancel"),
                React.createElement(Button, { disabled: !inputMatchesConsentText, onClick: props.onRotate, variant: !inputMatchesConsentText || isRotateLoading
                        ? "normal"
                        : "primary", loading: isRotateLoading }, "Accept"))) },
        React.createElement(SpaceBetween, { size: "m" },
            (props === null || props === void 0 ? void 0 : props.confirmationBody) || '',
            React.createElement(ColumnLayout, { columns: 2 },
                React.createElement("form", { onSubmit: handleRotateSubmit },
                    React.createElement(FormField, { label: `Type "${props.rotateModalStrings.consentText}" to agree.` },
                        React.createElement(Input, { autoComplete: "off", placeholder: props.rotateModalStrings.consentText, onChange: (event) => setRotateInputText(event.detail.value), value: rotateInputText, ariaRequired: true, ariaLabelledby: "rotate-confirmation-label" })))))));
};
export default ConfirmationModal;
